import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CategoryStreamService_GetAdditionalProductStreamV2Lazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/category_page/v1/stream/service.grpc.lazy';
import {useHydrationDone} from '@aboutyou/lazy-imports';
import {useSrtParam} from '@aboutyou/router';
import {
  useBasketTokenAwaitedAnySession,
  useNavigationBackOptimizedBasketToken,
} from '@aboutyou/user';
import {useAnyFilterFlyoutOpened} from '../../../features/Filters/shared/useAnyFilterFlyoutOpened';
import {PRODUCTS_PER_PAGE} from '../../../features/ProductStream/constants';
import {labelToSortingOption} from '../../../features/ProductStream/helpers';
import {useAppliedPotentialFilters} from '../../../features/ProductStream/utils';
import {useSorting} from '../../../features/ProductStream/utils/useSorting';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useProtoProductImageType} from '../../../shared-deprecated/useProductImageType';
import {useAppliedQuickFilter} from './useAppliedQuickFilter';
import {
  useCategoryCacheKeyTransformer,
  useCategoryIdentifier,
} from './useCategoryIdentifier';

export const useAdditionalProductsByPage = (page: number) => {
  const appliedFilters = useAppliedPotentialFilters();
  const appliedQuickFilter = useAppliedQuickFilter();
  const {sorting} = useSorting();
  const categoryIdentifier = useCategoryIdentifier();
  const categoryCacheKeyTransformer = useCategoryCacheKeyTransformer();
  const isFilterFlyoutOpen = useAnyFilterFlyoutOpened();

  const {basketToken} = useNavigationBackOptimizedBasketToken({
    uniqueKey: 'additional__product_stream',
  });
  const {session, refetchesDisabled} = useBasketTokenAwaitedAnySession();
  const preferredImage = useProtoProductImageType();
  const isHydrationDone = useHydrationDone();
  const sortingChannel = useSrtParam();

  return useGrpcRequest(
    CategoryStreamService_GetAdditionalProductStreamV2Lazy,
    {
      category: {
        identifier: categoryIdentifier,
      },
      pagination: {
        offset: (page - 1) * PRODUCTS_PER_PAGE,
        limit: PRODUCTS_PER_PAGE,
      },
      appliedFilters: {
        filters: appliedFilters,
        quickFilter: appliedQuickFilter,
      },
      sortOptions: labelToSortingOption(sorting),
      session,
      reductionsState: useReductionsStateRequestParameter(),
      basketToken,
      preferredProductImageType: preferredImage,
      sortingChannel,
    },
    {
      disabled: isFilterFlyoutOpen || !isHydrationDone || refetchesDisabled,
      transformCacheKey: categoryCacheKeyTransformer,
    },
  );
};
